import React from "react";
import classNames from "classnames/bind";

import logo_short from "../../icons/logo-short.svg";

import { Title } from "../Title";

import styles from "./ScreenInfo.module.css";
import { useStateManager } from "utils/useStateManager";

const cx = classNames.bind(styles);

type Props = {
  icon?: React.ComponentType<any> | null;
  title?: React.ReactNode;
};

const DefaultIcon = () => {
  const { linkInfo } = useStateManager();
  const logo = {
    src: linkInfo?.logo || logo_short,
    width: 40,
    height: 40,
  }

  if (linkInfo?.custom?.custom_additional_data?.logo) {
    logo.src = linkInfo?.custom?.custom_additional_data.logo;
  }

  if (linkInfo?.custom?.custom_additional_data?.logo_welcome_size) {
    const [width, height] = linkInfo?.custom?.custom_additional_data.logo_welcome_size.split("x");
    logo.width = +width;
    logo.height = +height;
  }

  if (linkInfo?.custom?.custom_additional_data?.logo_success_registration_size) {
    const [width, height] = linkInfo?.custom?.custom_additional_data.logo_success_registration_size.split("x");
    logo.width = +width;
    logo.height = +height;
  }

  return <img src={logo.src} width={logo.width} height={logo.height} alt="" />;
};

export const ScreenInfo: React.FC<Props> = ({
  icon: Icon = DefaultIcon,
  title,
  children,
}) => {
  return (
    <section className={cx("container")}>
      {Icon && (
        <div className={cx("icon")}>
          <Icon />
        </div>
      )}

      {title && (
        <div className={cx("title")}>
          <Title>{title}</Title>
        </div>
      )}

      {children}
    </section>
  );
};
